import React, { Component } from 'react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { Upload } from '../Outils/Upload';
import { ComboBoxDocumentOperationCategorie } from '../ComboBox/ComboBoxDocumentOperationCategorie';
import { ComboBoxDocumentOperationType } from '../ComboBox/ComboBoxDocumentOperationType';
import { ComboBoxDocumentLotCategorie } from '../ComboBox/ComboBoxDocumentLotCategorie';
import { ComboBoxDocumentLotType } from '../ComboBox/ComboBoxDocumentLotType';
import { ComboBoxDocumentReservationCategorie } from '../ComboBox/ComboBoxDocumentReservationCategorie';
import { ComboBoxDocumentReservationType } from '../ComboBox/ComboBoxDocumentReservationType';
import { ComboBoxLotsOperation } from '../ComboBox/ComboBoxLotsOperation';

import './FicheImportDocument.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { Data } from '../../data/Data.jsx';
import { DataDocument } from '../../data/DataDocument';
import { DataOperation } from '../../data/DataOperation';
import { withRouter } from 'react-router-dom';
import { EUIComboBox } from '../EUI/EUIComboBox';
import PerimetreContext from '../../contexts/PerimetreContext';

/****************************************************************
 PROPS:
    onAffichePanelImportDocument
    onFermeFicheImportDocument
    idReservation //Depuis dossier client de la réservation
    idOperation //Depuis dossier client de la réservation
****************************************************************/
let perimetre = 'National';
let idOperationPerimetre = 0;
let idAgencePerimetre = 0;
let idRegionPerimetre = 0;
let idReservation = 0;

var objetState = {
    documents: [],
    documentEnCours: {},
    onAffichePanelTypageDocument: false,
    onActiveBoutonEnregistrer: false,
    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
    hideMessageBarSuccess: true,
    successMessage: ''
};

const FicheImportDocumentComponent = class extends React.Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffichePanelImportDocument}
                type={PanelType.extraLarge}
                onDismiss={() => this._onAnnulation()}
                headerText='Importer des documents'
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.className}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                successMessage={this.state.successMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissSuccessMessage={() => this.setState({ successMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <Upload label="Sélectionner les fichiers à importer" multiple onChange={(e) => this._onUploadFileChange(e)} />

                            <DetailsList
                                items={this.state.documents}
                                columns={this.columns}
                                selectionMode={SelectionMode.none}
                            />

                            {this._creationContentTypageDocument()}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }
    _creationContentTypageDocument() {

        const desactiveZone = perimetre !== 'Opération' // Zone inactive si périmètre du document != opération...
            || this.state.documentEnCours === null // ou si document inexistant...
            || this.state.documentEnCours.typeDocument === undefined // Ou si type du document (opération ou lot) inexistant
            || this.state.documentEnCours.typeDocument === null;
        const desactiveZoneOperation = desactiveZone || this.state.documentEnCours.typeDocument !== "Operation"; // Section Opération inactive si type != opération
        const desactiveZoneLot = desactiveZone || this.state.documentEnCours.typeDocument !== "Lot"; // Section Lot inactive si type != lot

        return (
            <Panel
                isOpen={this.state.onAffichePanelTypageDocument}
                type={PanelType.medium}
                onDismiss={() => this._onCachePanelTypeDocument()}
                headerText={`Typer le document ${this.state.documentEnCours.nom}`}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContentTypeDocument}
            >
                <div className={this.props.className}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {perimetre === 'Opération' ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-xl6" name="divType">
                                        <EUIComboBox
                                            label="Type"
                                            onChange={(event, option) => this._onModificationTypeDocument(option.key)}
                                            options={[
                                                { key: 'Operation', text: 'Opération' },
                                                { key: 'Lot', text: 'Lot' }
                                            ]}
                                            required
                                            selectedKey={(this.state.documentEnCours != null ? this.state.documentEnCours.typeDocument : 'Opération')}
                                        />
                                    </div>
                                </div>
                                : null}

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                    <div className="ms-font-xl titreRubriqueImportDocument">{`Type document ${perimetre}`}</div>
                                </div>
                            </div>

                            {perimetre === 'Réservation' ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                                        <ComboBoxDocumentReservationCategorie
                                            onChange={(event, option) => this._onChangeDocumentReservationCategorie(option.key)}
                                            required
                                            selectedKey={this.state.documentEnCours.idDocumentReservationCategorie}
                                        />
                                    </div>
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                                        <ComboBoxDocumentReservationType
                                            disabled={!this.state.documentEnCours.idDocumentReservationCategorie}
                                            idDocumentReservationCategorie={this.state.documentEnCours.idDocumentReservationCategorie}
                                            onChange={(event, option, index, value, item) => this._onChangeDocumentReservationType(option.key)}
                                            required
                                            selectedKey={this.state.documentEnCours.idDocumentReservationType}
                                        />
                                    </div>
                                </div> :
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-xl6" name="divCategorie">
                                        <ComboBoxDocumentOperationCategorie
                                            disabled={desactiveZoneOperation}
                                            onChange={(event, option) => this._onChangeDocumentOperationCategorie(option.key)}
                                            required
                                            selectedKey={this.state.documentEnCours.idDocumentOperationCategorie}
                                        />
                                    </div>
                                    <div className="ms-Grid-col ms-sm12 ms-xl6" name="divSousCategorie">
                                        <ComboBoxDocumentOperationType
                                            disabled={desactiveZoneOperation}
                                            idDocumentOperationCategorie={this.state.documentEnCours.idDocumentOperationCategorie}
                                            onChange={(event, option, index, value, item) => this._onChangeDocumentOperationType(option.key)}
                                            required
                                            selectedKey={this.state.documentEnCours.idDocumentOperationType}
                                        />
                                    </div>
                                </div>
                            }

                            {perimetre === 'Opération' ?
                                <div>
                                    <div className="separateur"></div>

                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12">
                                            <div className="ms-font-xl titreRubriqueImportDocument">Lot</div>
                                        </div>
                                    </div>

                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-xl4">
                                            <ComboBoxLotsOperation
                                                disabled={desactiveZoneLot}
                                                idOperation={idOperationPerimetre}
                                                onChange={(event, option, index, value, item) => this._onChangeLotsOperation(option.key)}
                                                required
                                                selectedKey={this.state.documentEnCours.idLot}
                                            />
                                        </div>
                                        <div className="ms-Grid-col ms-sm12 ms-xl4">
                                            <ComboBoxDocumentLotCategorie
                                                disabled={desactiveZoneLot || !this.state.documentEnCours.idLot}
                                                onChange={(event, option) => this._onChangeDocumentLotCategorie(option.key)}
                                                required
                                                selectedKey={this.state.documentEnCours.idDocumentLotCategorie}
                                            />
                                        </div>
                                        <div className="ms-Grid-col ms-sm12 ms-xl4">
                                            <ComboBoxDocumentLotType
                                                disabled={desactiveZoneLot || !this.state.documentEnCours.idDocumentLotCategorie}
                                                idDocumentLotCategorie={this.state.documentEnCours.idDocumentLotCategorie}
                                                onChange={(event, option) => this._onChangeDocumentLotType(option.key)}
                                                required
                                                selectedKey={this.state.documentEnCours.idDocumentLotType}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        this.columns = [
            {
                key: 'id', name: 'ID', fieldName: 'id', minWidth: 50, maxWidth: 50
            },
            {
                key: 'nomFichier', name: 'Nom fichier', fieldName: 'nomFichier', minWidth: 300, maxWidth: 800, isResizable: true,
                onRender: (item) => {
                    return <span>{item.nom}</span>;
                }
            },
            {
                key: 'taille', name: 'Taille', fieldName: 'taille', minWidth: 80, maxWidth: 80,
                onRender: (item) => {
                    return <span>{this._getFileSizeString(item.size)}</span>;
                }
            },
            {
                key: 'perimetre', name: 'Périmètre', fieldName: 'perimetre', minWidth: 100, maxWidth: 200, isResizable: true,
                onRender: () => {
                    return <span>{perimetre}</span>;
                }
            },
            {
                key: 'edition', name: '', fieldName: 'edition', minWidth: 20, maxWidth: 20, isIconOnly: true,
                onRender: (item) => {
                    return <IconButton iconProps={{ iconName: 'Edit' }} title="Typer le document" ariaLabel="Typer le document" onClick={() => this._onAffichePanelTypeDocument(item)} />;
                }
            },
            {
                key: 'delete', name: '', fieldName: 'delete', minWidth: 20, maxWidth: 20, isIconOnly: true,
                onRender: (item) => {
                    return <IconButton iconProps={{ iconName: 'Delete' }} title="Supprimer le document" ariaLabel="Supprimer le document" onClick={() => this._onSuppressionDocument(item.id, false)} />;
                }
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _recuperationPerimetre() {
        //Depuis le dossier client de la réservation - On prend l'IdOperation passé en props car le périmetre n'est pas forcément renseigné
        if (this.props.idReservation > 0 && this.props.idOperation > 0) {
            perimetre = 'Réservation';
            idReservation = this.props.idReservation;
            idOperationPerimetre = this.props.idOperation;
        } else {  //Depuis l'interface d'ajout de documents - Le périmetre est toujours renseigné

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Chargement du périmètre en cours"
            });

            var verificationSiPerimetreExiste = Data._verificationSiPerimetreExiste();

            verificationSiPerimetreExiste
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let idOperation = objetData[0];
                        let idAgence = objetData[1];
                        let idRegion = objetData[2];

                        idOperationPerimetre = idOperation;
                        idAgencePerimetre = idAgence;
                        idRegionPerimetre = idRegion;

                        if (idOperationPerimetre === 0 || idAgencePerimetre === 0) {
                            this.props.history.push('/Operations/ListeOperations');
                        }

                        if (idOperationPerimetre > 0) {
                            perimetre = 'Opération';
                        }
                        else if (idAgencePerimetre > 0) {
                            perimetre = 'Agence';
                        }
                        else if (idRegionPerimetre > 0) {
                            perimetre = 'Région';
                        }
                        else {
                            perimetre = 'National';
                        }

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }
    _onUploadFileChange(event) {
        let fichiers = event.target.files;

        if (fichiers.length > 0) {
            let tabFichiers = [];

            for (var i = 0; i < fichiers.length; i++) {
                const reader = new FileReader();
                let fichier = fichiers[i];
                let idFichier = i + 1;

                reader.addEventListener('load', function () {
                    tabFichiers.push({ id: idFichier, nom: fichier.name, size: fichier.size, fileData: Scriba.fichier().ByteArrayVersBase64(reader.result), src: window.URL.createObjectURL(fichier) });
                });

                reader.readAsArrayBuffer(fichier);
            }

            this.setState({ documents: tabFichiers });
        }
    }
    _getFileSizeString = (fileSize) => {
        var i = -1;
        var byteUnits = [' Ko', ' Mo', ' Go'];

        do {
            fileSize = fileSize / 1024;
            i++;
        } while (fileSize > 1024);

        return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i];
    };

    _onChangeDocumentOperationCategorie = (idDocumentOperationCategorie) => {
        let document = { ...this.state.documentEnCours };
        document.idDocumentOperationCategorie = idDocumentOperationCategorie;

        this.setState({
            documentEnCours: document
        }, this._onVerificationFormulaire);
    }
    _onChangeDocumentOperationType = (idDocumentOperationType) => {
        // Empêcher de charger les plaquettes commerciales supérieures à 3 Mo
        let estValide = this._verificationPlaquetteCommerciale(idDocumentOperationType);
        let estImageCapsuleValide = this._verificationImageCapsule(idDocumentOperationType);
        let document = { ...this.state.documentEnCours };
        document.idDocumentOperationType = idDocumentOperationType;

        if (!estValide) {
            this.setState({
                documentEnCours: document,
                hideMessageBarWarning: false,
                warningMessage: 'Votre fichier est trop lourd, le poids maximum autorisé pour une plaquette commerciale est de 3 Mo.'
            }, this._onVerificationFormulaire);
        }
        else if (!estImageCapsuleValide) {
            this.setState({
                documentEnCours: document,
                hideMessageBarWarning: false,
                warningMessage: 'Seul le format PNG est autorisé pour ce type de document.'
            }, this._onVerificationFormulaire);
        }
        else {
            this.setState({
                documentEnCours: document,
                hideMessageBarWarning: true,
                warningMessage: ''
            }, this._onVerificationFormulaire);
        }
    }

    _onChangeDocumentReservationCategorie = (idDocumentReservationCategorie) => {
        let document = { ...this.state.documentEnCours };
        document.idDocumentReservationCategorie = idDocumentReservationCategorie;
        document.idDocumentReservationType = 0;
        document.typeDocument = 'Réservation';

        this.setState({
            documentEnCours: document
        }, this._onVerificationFormulaire);
    }
    _onChangeDocumentReservationType = (idDocumentReservationType) => {
        let document = { ...this.state.documentEnCours };
        document.idDocumentReservationType = idDocumentReservationType;
        document.typeDocument = 'Réservation';

        this.setState({
            documentEnCours: document,
            hideMessageBarWarning: true,
            warningMessage: ''
        }, this._onVerificationFormulaire);
    }

    _onChangeDocumentLotCategorie = (idDocumentLotCategorie) => {
        let document = { ...this.state.documentEnCours };
        document.idDocumentLotCategorie = idDocumentLotCategorie;
        document.idDocumentLotType = 0;

        this.setState({
            documentEnCours: document
        }, this._onVerificationFormulaire);
    }
    _onChangeDocumentLotType = (idDocumentLotType) => {
        let estPlanDeVenteValide = this._verificationPlanDeVente(idDocumentLotType);
        let document = { ...this.state.documentEnCours };
        document.idDocumentLotType = idDocumentLotType;

        if (!estPlanDeVenteValide) {
            this.setState({
                documentEnCours: document,
                hideMessageBarWarning: false,
                warningMessage: 'Le nom du plan de vente doit contenir uniquement des lettres et/ou des chiffres, son format doit être PDF.'
            }, this._onVerificationFormulaire);
        }
        else {
            this.setState({
                documentEnCours: document,
                hideMessageBarWarning: true,
                warningMessage: ''
            }, this._onVerificationFormulaire);
        }
    }

    _onChangeLotsOperation = (idLot) => {
        let document = { ...this.state.documentEnCours };
        document.idLot = idLot;
        document.idDocumentLotCategorie = 0;
        document.idDocumentLotType = 0;

        this.setState({
            documentEnCours: document
        }, this._onVerificationFormulaire);
    }

    _onModificationTypeDocument(valeur) {
        let document = { ...this.state.documentEnCours };
        document.typeDocument = valeur;

        document.idLot = 0;
        document.idDocumentLotCategorie = 0;
        document.idDocumentLotType = 0;
        document.idDocumentOperationCategorie = 0;
        document.idDocumentOperationType = 0;

        this.setState({
            documentEnCours: document
        }, this._onVerificationFormulaire);
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'Document', this.state.documentEnCours, 'Création');
    }
    _verificationPlanDeVente = (idDocumentLotType) => {
        let estValide = true;
        let nomFichier = this.state.documentEnCours.nom;

        if (nomFichier !== undefined) {
            // Les noms des plans de vente ne doivent pas contenir de caractères spéciaux et doivent être en PDF obligatoirement
            if (idDocumentLotType === 1) {
                let nomFichierSansExtension = nomFichier.split('.')[0];
                let extension = Scriba.chaine().getExtensionFichier(nomFichier);

                if (extension.toLowerCase() === 'pdf') {
                    let regex = /^[a-zA-Z0-9]+$/;

                    if (!regex.test(nomFichierSansExtension)) {
                        estValide = false;
                    }
                }
                else {
                    estValide = false;
                }
            }
        }
        else {
            estValide = false;
        }

        return estValide;
    }
    _verificationImageCapsule = (idDocumentOperationType) => {
        let estValide = true;
        let nomFichier = this.state.documentEnCours.nom;

        if (nomFichier !== undefined) {
            // Les images de la capsule sont en PNG impérativement
            if (idDocumentOperationType === 27 || idDocumentOperationType === 28 || idDocumentOperationType === 29) {
                let extension = Scriba.chaine().getExtensionFichier(nomFichier);

                if (extension.toLowerCase() !== 'png') {
                    estValide = false;
                }
            }
        }
        else {
            estValide = false;
        }

        return estValide;
    }
    _verificationPlaquetteCommerciale = (idDocumentOperationType) => {
        let estValide = true;
        const fsize = Math.round((this.state.documentEnCours.size / 1024));

        if (idDocumentOperationType === 16 && fsize > 3072) {
            estValide = false;
        }

        return estValide;
    }

    _onAffichePanelTypeDocument = (item) => {
        this.setState({
            onAffichePanelTypageDocument: true,
            documentEnCours: item,
            hideMessageBarSuccess: true,
            successMessage: ''
        });
    };
    _onCachePanelTypeDocument = () => {
        this.setState({
            documentEnCours: {},
            onAffichePanelTypageDocument: false,
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: ''
        });
    };

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton name="btnFermerList" onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };
    _onRenderFooterContentTypeDocument = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrer" onClick={() => this._onEnregistrement()} disabled={!this.state.onActiveBoutonEnregistrer} style={{ marginRight: '8px' }}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onCachePanelTypeDocument()}>Fermer</DefaultButton>
            </div>
        );
    };

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du document en cours'
        });

        let idDocument = this.state.documentEnCours.id;

        let onEnregistrementImportDocument = DataDocument._onEnregistrementImportDocument(this.state.documentEnCours, idOperationPerimetre, idAgencePerimetre, idRegionPerimetre, this.props.idReservation);

        onEnregistrementImportDocument
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onCachePanelTypeDocument();
                    this._onSuppressionDocument(idDocument, true);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }
    _onSuppressionDocument = (index, onAfficheMessageSucces) => {
        let tableauDocuments = [...this.state.documents];
        let element = tableauDocuments.find(d => d.id === index);
        let i = tableauDocuments.indexOf(element);

        tableauDocuments.splice(i, 1);

        this.setState({
            documents: tableauDocuments,
            hideMessageBarSuccess: !onAfficheMessageSucces,
            successMessage: (onAfficheMessageSucces ? 'Le document a bien été enregistré.' : '')
        });
    }
    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheImportDocument();
    }

    componentDidMount() {
        this._recuperationPerimetre();
    }
    componentWillUnmount() {
    }
    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._recuperationPerimetre();
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._recuperationPerimetre();
    };

    render() {
        return this._creationContent();
    }
}

const FicheImportDocumentWithPerimetre = withRouter(FicheImportDocumentComponent);

export class FicheImportDocument extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <FicheImportDocumentWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};